import { Button } from "@component/button";
import {
    Tooltip,
    TooltipProvider,
} from "@component/tooltip";
import { EmailTemplate } from "@type/setting";
import { EditIcon, TrashIcon } from "lucide-react";

interface Props {
    template: EmailTemplate;
    isViewMode: boolean;
    hasChanges?: boolean;
    onEdit: () => void;
    onSave: () => void;
    onCancel: () => void;
    onDelete: (template: EmailTemplate) => void;
}

export default function TemplateActions(props: Props) {
    const DeleteButton = () => {
        const button = (
            <Button
                variant="ghost"
                size="sm"
                onClick={() => !props.template.is_default && props.onDelete(props.template)}
                disabled={props.template.is_default}
                className={`px-4 py-2 text-sm h-auto ${props.template.is_default
                    ? "text-gray-300 cursor-not-allowed"
                    : "text-gray-500 hover:text-red-600 hover:bg-red-50"
                    }`}
            >
                <TrashIcon className="h-4 w-4" />
            </Button>
        );

        if (props.template.is_default) {
            return (
                <TooltipProvider>
                    <Tooltip
                        side="left"
                        content={(
                            <p className="text-sm">
                                Default templates cannot be deleted but can be edited.
                            </p>
                        )}
                    >
                        {button}
                    </Tooltip>
                </TooltipProvider>
            );
        }

        return button;
    };

    if (props.isViewMode) {
        return (
            <div className="flex items-center space-x-2 flex-shrink-0">
                <Button
                    variant="outline"
                    size="sm"
                    onClick={props.onEdit}
                    className="px-4 py-2 text-sm h-auto"
                >
                    <EditIcon className="h-4 w-4 mr-1" />
                    Edit
                </Button>
                <DeleteButton />
            </div>
        );
    }

    return (
        <div className="flex items-center space-x-2 flex-shrink-0">
            <Button
                variant="outline"
                size="sm"
                onClick={props.onCancel}
                className="px-4 py-2 text-sm h-auto"
            >
                Cancel
            </Button>
            <Button
                size="sm"
                onClick={props.onSave}
                className="bg-blue-600 hover:bg-blue-700 text-white disabled:opacity-50 disabled:cursor-not-allowed px-4 py-2 text-sm h-auto"
                disabled={!props.hasChanges}
            >
                Save Changes
            </Button>
            <DeleteButton />
        </div>
    );
}
